import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import EntryFactorSave from "./EntryFactorSave";


const EntryFactorNew = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    const handleFormSubmit = (e) => {

        let entryfactorid = "";

        let valid = true;

        let factor = "";
        if (document.getElementById("entryFactor").value != '') {
            factor = document.getElementById("entryFactor").value;
            if(!isNaN(factor)) {
                let oldFactor = factor;
                factor = parseFloat(factor).toFixed(2);
                if(parseFloat(factor) != parseFloat(oldFactor)) {
                    toast(`Entry Factor rounded to ${factor} from ${oldFactor}`);
                }
            }
            else {
                toast.error("Entry Factor must be a number");
            }
        }
        else {
            valid = false;
            toast.error("Entry Factor required");
        }

        let modifiedbyid = user["id"];
        let deleted = "0";

        if (valid) {
            EntryFactorSave(entryfactorid, factor, modifiedbyid, deleted);
            toast.success('Success');
            navigate("/EntryFactor");
        }
    };

    document.title = "Entry Factor - New";
    return ( 
        <div className="entryFactorNew">
            {user["email"] != undefined && 
                <>
                    <div className="container body-content" style={{marginTop: "25px"}}>
                            
                    <h2>New Entry Factor</h2>

                        <form id="entryFactorForm" noValidate="novalidate" autoComplete="off">    

                            <div className="form-group">
                                <label htmlFor="entryFactor">Entry Factor</label>
                                <input className="form-control" id="entryFactor" name="entryFactor" type="text" autoComplete="off" />
                            </div>

                        </form> 
                        <Link to="/EntryFactor" className="btn btn-primary" style={{marginRight: "4px"}}>Cancel</Link>                           
                        <button onClick={handleFormSubmit} className="btn btn-primary" style={{marginRight: "4px"}}>Save</button>                        
                    </div>
                </>
            }
        </div>
     );
}
 
export default EntryFactorNew;